import { http } from "@/utils/http";

/** 获取用户相关信息 /bi/query */
export const userBi = data => {
  return http.request("post", "/biz/user/bi/query", { data });
};

/**
 * 获取用户历史记录
 */
export const getUserRecentHistory = data => {
  return http.request("get", `/biz/user/usage/history/recent`, {
    params: data
  });
};
/**
 * 设置用户搜索历史记录
 */
export const setUserRecentHistory = data => {
  return http.request("post", `/biz/user/usage/history/log`, {
    data
  });
};
/**
 * 删除用户历史记录
 */
export const clearUserRecentHistory = data => {
  return http.request("post", `/biz/user/usage/history/clear`, {
    data
  });
};

// https://hotel.charmdeer.com/services/biz/user/toggle/i18n
export const toggleI18n = data => {
  return http.request("post", `/biz/user/toggle/i18n`, {
    data
  });
};

export const getTokenData = () => {
  return http.get("/biz/util/oss/qiniu/getUploadToken", {});
};

export const getUploadToken = () => {
  return http.get("/biz/util/getUploadToken", {});
};
/**
 * 获取登录token
 */
export const getUserSerializeAsToken = async () => {
  const res = await http.get("biz/user/auth/serializeAsToken", {});
  return res.token;
};

/**
 * 获取搜索历史
 */
export const getSearchLog = async type => {
  const res = await http.get("biz/user/usage/history/recent", {
    type
  });
  return res.results || [];
};

/**
 * 更新traveler
 * @param {*} data
 * @returns
 */
export const upsertTraveler = async data => {
  const res = await http.post("/biz/tourist/upsert", { data });
  return res;
};

/**
 * 更新traveler
 * @param {*} data
 * @returns
 */
export const updateTourist = async data => {
  const res = http.patch(`rest/tourists/${data._id}`, { data });
  return res;
};

/**
 * 新增traveler
 * @param {*} data
 * @returns
 */
export const createTourist = async data => {
  const res = http.post("rest/tourists", { data });
  return res;
};

/**
 * 获取 traveler list
 * @returns
 */
export const getTravelerList = async () => {
  const res = await http.get("rest/tourists", {
    // params: {
    //   query: JSON.stringify({ fixed: true })
    // },
    query: JSON.stringify({ fixed: true }),
    // fixed: true,
    sort: "-createdAt"
  });
  return res;
};

/**
 * 删除contact
 * @param {} ref
 * @returns
 */
export const deleteTraveler = async ref => {
  await http.patch(`rest/tourists/${ref}`, { data: { fixed: false } });
  return 0;
};

export const getUserLevel = async () => {
  const userLevelRes = await http.get("/render/y/user/levels", {});
  return userLevelRes;
};

export const searchUserByKeyword = async keyword => {
  const userLevelRes = await http.get("/biz/user/find/keyword", { keyword });
  return userLevelRes.users;
};

export const activateMember = async form => {
  const res = await http.post(
    "/biz/loyaltyProgram/hotelux/matchCardBin/match",
    { data: form }
  );
  return res;
};

export const matchCardBinPrepare = async form => {
  const res = await http.post(
    "/biz/loyaltyProgram/hotelux/matchCardBin/prepare",
    { data: form }
  );
  return res;
};

export const createMatchCardSetupIntent = async data => {
  let res;
  if (data.category === "diners" || data.category === "jcb") {
    res = await http.post("/biz/payment/stripe/createSetupIntent", {
      data
    });
  } else {
    res = await http.post(
      "/biz/payment/stripe/createSetupIntent?alternativeChannelKey=hotelux",
      { data }
    );
  }
  return res;
};

export const logInfo = async (message, info) => {
  const res = await http.post("/biz/util/logging/client/logInfo", {
    data: { message, info }
  });
  return res;
};

export const maintainTrack = async data => {
  const res = await http.post("/biz/loyaltyProgram/maintain/track", {
    data
  });
  return res;
};
